<div [style.background-image]="picture | avatarImage" [class.has-picture]="picture" [class.placeholder]="placeholder">
    <span *ngIf="picture === null || picture === undefined || picture === ''" class="name-icon">
        <ng-content></ng-content>
    </span>
</div>
